import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../../context.js';

import Loading from '../../../components/loading.js';
import Helmet from "../../../components/helmet.js";

function AccountingStatistics() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState([]);

  useEffect(() => {
    let u = context.addSpiner();
    axios.post('/api/admin/analytics/accounting/statistics', {})
      .then((response) => {
        setStatistics(response.data || []);
        setLoading(false);
      })
      .catch((e) => {
        context.addError(e);
        setLoading(false);
      })
      .finally(() => {
        context.removeSpiner(u);
      });
  }, []);

  function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function renderStatistics() {
    if (!statistics || statistics.length === 0) {
      return (
        <div className="card mb-2">
          <div className="card-header sm">
            <div className="typo-normal-150">No partner accounting data available.</div>
            <div className="typo-normal-125 text-muted mt-2">This means there are no transactions associated with partners in patient accounts.</div>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="card mb-2">
          <div className="card-header sm">
            <div className="row">
              <div className="col-xs-6">
                <div className="typo-strong-150">Partner Name</div>
              </div>
              <div className="col-xs-3 text-end">
                <div className="typo-strong-150">Total Transactions</div>
              </div>
              <div className="col-xs-3 text-end">
                <div className="typo-strong-150">Total Amount</div>
              </div>
            </div>
          </div>
        </div>

        {statistics.map((item, index) => (
          <div key={item.partnerID || index} className="card mb-2">
            <div className="card-header sm">
              <div className="row">
                <div className="col-xs-6">
                  <div className="typo-normal-150">{item.partnerName || 'Unknown Partner'}</div>
                </div>
                <div className="col-xs-3 text-end">
                  <div className="typo-normal-150">{item.totalTransactions || 0}</div>
                </div>
                <div className="col-xs-3 text-end">
                  <div className="typo-normal-150">{formatCurrency(item.totalAmount || 0)}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  }

  if (loading) {
    return (
      <>
        <Helmet title="Accounting Statistics" />
        <Loading />
      </>
    );
  }

  return (
    <>
      <Helmet title="Accounting Statistics" />

      <div className="container">
        <div className="row mb-4">
          <div className="col-xs-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Partner Accounting Statistics</div>
                <div className="typo-normal-175">Track partner spending from patient account balances. View total transactions and amounts per partner.</div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            {renderStatistics()}
          </div>
        </div>
      </div>
    </>
  );
}

export default AccountingStatistics;

